import Vue from "vue";
import axios from 'axios';
import { BUILDER_TYPE, BUILDER_USER_TYPE, FORM_TYPE } from "../constants/custom-define-type";
import { MAP_DIALOG_SECTION } from "../constants/field-types";

Vue.mixin({
    methods: {
        /*
        Replace tag with value defined in object
        listTags contains tag information: [[tag]] in input and corresponding model field in object
        otherMapValues contains map: key => value to replace
        */
        replacePredefinedTag(input, object, listTags, otherMapValues) {
            if (!input) {
                return "";
            }
            let result = input;
            for (const tag of listTags) {
                let value = "";
                if (object) {
                    value = object[tag.model];
                }
                result = this.replaceAllText(result, `[[${tag.tag}]]`, value);
            }
            result = this.replaceTagByMap(result, otherMapValues);
            return result;
        },
        /*
        mapValues contains map: key => value to replace
        key is in a tag, for example: tag is [[fname]] => key is fname
        */
        replaceTagByMap(input, mapValues) {
            if (!input) {
                return "";
            }
            let result = input;
            if (mapValues) {
                for (const key of Object.keys(mapValues)) {
                    const value = mapValues[key];
                    result = this.replaceAllText(result, `[[${key}]]`, value);
                }
            }
            return result;
        },
        /*
        mapValues contains map: key => value to replace
        */
        replaceAllByMap(input, mapValues) {
            if (!input) {
                return "";
            }
            let result = input;
            if (mapValues) {
                for (const key of Object.keys(mapValues)) {
                    const value = mapValues[key];
                    result = this.replaceAllText(result, key, value);
                }
            }
            return result;
        },
        // Remove all text in listText in input string
        removeTextInString(input, listText) {
            if (!input) {
                return "";
            }
            let result = input;
            if (listText) {
                for (const text of listText) {
                    result = this.replaceAllText(result, text, "");
                }
            }
            return result;
        },
        makeJobStringSubstitutions(string, job, client, candidate, keepCustomTags = false) {
            console.log(candidate);
            return new Promise(async (resolve) => {
                // In the job email templates need to substitute in all of the variables

                // https://stackoverflow.com/questions/13340131/javascript-replaceall-not-working
                let jobDateString = '';
                let compressedDate = '';
                if (job.date) {
                    jobDateString = this.getDateString(job.date);
                    compressedDate = this.compressDateFormat(job.date);
                }
                string = string.split(`[[jobtitle]]`).join(job.title);
                string = string.split(`[[date]]`).join(jobDateString);
                string = string.split(`[[date_compressed]]`).join(compressedDate);
                // string = string.split(`[[start_time]]`).join(this.convertTimeToAMPM(job.start_time))
                // string = string.split(`[[end_time]]`).join(this.convertTimeToAMPM(job.end_time))
                // Replace job_dates tags
                if (string.includes('[[jobdates')) {
                    const listDateTimes = this.getListDateTimeOfJobs(job);
                    listDateTimes.forEach(dateTime => {
                        dateTime.start_time = dateTime.startTime;
                        dateTime.end_time = dateTime.endTime;
                    })
                    const jobDates = listDateTimes
                        .map((jobDate) => this.getDateString(jobDate.date))
                        .join(", ");
                    const jobDatesCompressed = listDateTimes
                        .map((jobDate) => this.compressDateFormat(jobDate.date))
                        .join(", ");
                    string = string.split(`[[jobdates]]`).join(jobDates);
                    string = string.split(`[[jobdates_compressed]]`).join(jobDatesCompressed);
                    string = string.split(`[[jobdatestimes]]`).join(this.getJobsDatesTimes(listDateTimes));
                    string = string.split(`[[jobdatestimes_compressed]]`).join(this.getJobsDatesTimesCompressed(listDateTimes));
                }

                let startTime = job.start_time;
                if (typeof startTime === 'object') {
                    startTime = this.getTimeString(job.start_time);
                }
                string = string
                    .split(`[[starttime]]`)
                    .join(this.djangotimeformatAMPM(startTime));
                string = string
                    .split(`[[start_time]]`)
                    .join(this.djangotimeformatAMPM(startTime));
                string = string
                    .split(`[[starttime_compressed]]`)
                    .join(this.compressTimeFormat(startTime));
                let endTime = job.end_time;
                if (typeof endTime === 'object') {
                    endTime = this.getTimeString(job.end_time);
                }
                string = string
                    .split(`[[endtime]]`)
                    .join(this.djangotimeformatAMPM(endTime));
                string = string
                    .split(`[[end_time]]`)
                    .join(this.djangotimeformatAMPM(endTime));
                string = string
                    .split(`[[endtime_compressed]]`)
                    .join(this.compressTimeFormat(endTime));
                string = string.split(`[[candidaterate]]`).join(job.candidate_rate ? job.candidate_rate : '');
                let clientRate = Number(job.client_rate) || 0;
                if (!clientRate) {
                    if (job.candidate_rate) {
                        clientRate = Number(job.candidate_rate);
                    }
                    if (job.agency_fee) {
                        clientRate = clientRate + Number(job.agency_fee);
                    }
                }
                if (clientRate) {
                    clientRate = clientRate.toFixed(2);
                }
                string = string.split(`[[clientrate]]`).join(clientRate || '');
                string = string.split(`[[agencyfee]]`).join(job.agency_fee ? job.agency_fee : '');
                string = string.split(`[[travelfee]]`).join(job.travel_fee ? job.travel_fee : '');
                string = string.split(`[[per_booking_agency_fee]]`).join(job.per_booking_agency_fee || '');
                string = string.split(`[[clientnotes]]`).join(job.text);
                string = string.split(`[[agencynotes]]`).join(job.admin_notes);
                string = string.split(`[[jobid]]`).join(job.id);
                string = string.split(`[[jobids]]`).join(job.id);
                string = string.split(`[[address1]]`).join(job.address1 || '');
                string = string.split(`[[address2]]`).join(job.address2 || '');
                string = string.split(`[[city]]`).join(job.city || '');
                string = string.split(`[[state_province]]`).join(job.provincestate || '');
                string = string.split(`[[zip_postal_code]]`).join(job.postal_code || '');
                string = string.split(`[[country]]`).join(job.country || '');
                // Job link
                const jobLink = `${this.rootUrl}/job/` + job.id;
                string = string.split(`[[joblink]]`).join(jobLink);
                string = string.split(`[[joblinks]]`).join(jobLink);
                // Job Tipping link
                if (string.includes('[[jobtiplink]]') || string.includes('[[jobtiplinks]]')) {
                    const hashPosterId = await this.getHashId(job.poster + 1);
                    const jobTipLink = `${this.rootUrl}/job-tip/${job.id}/${hashPosterId}`;
                    string = string.split(`[[jobtiplink]]`).join(jobTipLink);
                    string = string.split(`[[jobtiplinks]]`).join(jobTipLink);
                }

                // Job Review Link 
                if (job.id && string.includes('[[review_link]]')) {
                    const jobReviewLink = `${this.rootUrl}/job/${this.$store.getters.agencyID}/${job.id}/add-review`;
                    string = string.split(`[[review_link]]`).join(jobReviewLink);
                }

                let address = job.address1;
                if (job.address2) {
                    // Not everyone has a second line in their address, don't want an extra space if they don't
                    address = address + " " + job.address2;
                }
                address =
                    address +
                    ", " +
                    job.city +
                    ", " +
                    job.provincestate +
                    ", " +
                    job.postal_code;
                string = string.split(`[[address]]`).join(address);

                if (candidate) {
                    console.log('candidate', candidate.first_name)
                    string = string.split(`[[candidatefname]]`).join(candidate.first_name);
                    string = string.split(`[[candidatelname]]`).join(candidate.last_name);
                    string = string.split(`[[candidatephone]]`).join(candidate.phone);
                    string = string.split(`[[candidateemail]]`).join(candidate.email);
                    // Replace candidate shareable link
                    if (string.includes('[[candidate_shareable_link]]')) {
                        const candidateShareableLink = await this.getShareableURL(candidate, true);
                        string = string.split(`[[candidate_shareable_link]]`).join(candidateShareableLink);
                    }
                }
                if (client) {
                    string = string.split(`[[clientfname]]`).join(client.first_name);
                    string = string.split(`[[clientlname]]`).join(client.last_name);
                    string = string.split(`[[clientphone]]`).join(client.phone);
                    string = string.split(`[[clientsecondary_phone]]`).join(client.phone2);
                    let clientTags = '';
                    if (client.tags) {
                        clientTags = client.tags.join(', ');
                    }
                    string = string.split(`[[clienttags]]`).join(clientTags);
                    // Replace client sharable link
                    if (string.includes('[[client_shareable_link]]')) {
                        const clientShareableLink = await this.getShareableURL(client, false);
                        string = string.split(`[[client_shareable_link]]`).join(clientShareableLink);
                    }
                    // Check children tag
                    if (string.includes('[[children]]') || string.includes('[[children_text]]') || string.includes('[[ages_of_children]]') || string.includes('[[ages_of_children_compressed]]')) {
                        const listChildren = await this.getListChildren(client);
                        if (string.includes('[[children]]') || string.includes('[[children_text]]')) {
                            const childrenContent = await this.getProfileSectionContent(client,
                                listChildren, MAP_DIALOG_SECTION.Children.name, true);
                            console.log(childrenContent);
                            string = string.split(`[[children]]`).join(childrenContent);
                            let childrenText = this.getHtmlText(childrenContent, true).trim();
                            const mapReplaced = {
                                '\n\n\n\n\n\n\n\n\n': '\n',
                                '\n\n\n\n\n\n\n\n': '\n',
                                '\n\n\n\n\n\n\n': '\n',
                                '\n\n\n\n\n\n': '\n',
                                '\n\n\n': ': '
                            }
                            childrenText = this.replaceAllByMap(childrenText, mapReplaced);
                            string = string.split(`[[children_text]]`).join(childrenText);
                        }
                        if (string.includes('[[ages_of_children]]')) {
                            const childrenAges = listChildren.map(child => this.getAge(child.birthday)).join('; ');
                            string = string.split(`[[ages_of_children]]`).join(childrenAges);
                        }
                        if (string.includes('[[ages_of_children_compressed]]')) {
                            const compressedChildrenAges = listChildren.map(child => this.getCompressedAge(child.birthday)).join(', ');
                            string = string.split(`[[ages_of_children_compressed]]`).join(compressedChildrenAges);
                        }
                    }
                }
                if (string.includes('[[pets]]')) {
                    const listPets = await this.getListPets(client);
                    const petsContent = await this.getProfileSectionContent(client, listPets, MAP_DIALOG_SECTION.Pet.name);
                    string = string.split(`[[pets]]`).join(petsContent);
                }
                if (string.includes('[[associated_shift_jobs]]')) {
                    const associatedShiftJobs = await this.getAssociatedBookingsInfo(job);
                    string = string.split(`[[associated_shift_jobs]]`).join(associatedShiftJobs);
                }
                if (string.includes('[[associated_shift_jobs_compressed]]')) {
                    const associatedShiftJobs = await this.getCompressedAssociatedBookingsInfo(job);
                    string = string.split(`[[associated_shift_jobs_compressed]]`).join(associatedShiftJobs);
                }
                // for replacing custom tags with their respective values e.g [[text2]]
                string = this.replaceTagValue(string, job, false, null, false, Object.keys(job));
                // Replace custom client tags
                if (client && Object.keys(client) && Object.keys(client).length) {
                    string = this.replaceAllText(string, '[[client_', '[[');
                    string = this.replaceTagValue(string, client, false, null, false, Object.keys(client));
                }
                // Replace custom candidate tags
                if (candidate && Object.keys(candidate) && Object.keys(candidate).length) {
                    string = this.replaceAllText(string, '[[candidate_', '[[');
                    string = this.replaceTagValue(string, candidate, false, null, false, Object.keys(candidate));
                }
                resolve(string);
            });
        },
        getAssociatedBookingsInfo(job) {
            return new Promise(async (resolve) => {
                if (!job.associated_job_group) {
                    resolve('');
                    return;
                }
                const res = await axios.get(
                    "/get-associated-job/?group_id=" + job.associated_job_group
                );
                const result = res.data.filter(
                    (booking) => booking.id !== job.id
                ).map(booking => this.getDateString(booking.date)).join(', ');
                resolve(result);
                return;
            });
        },
        getCompressedAssociatedBookingsInfo(job) {
            return new Promise(async (resolve) => {
                if (!job.associated_job_group) {
                    resolve('');
                    return;
                }
                const res = await axios.get(
                    "/get-associated-job/?group_id=" + job.associated_job_group
                );
                const result = res.data.filter(
                    (booking) => booking.id !== job.id
                ).map(booking => this.compressDateFormat(booking.date)).join(', ');
                resolve(result);
                return;
            });
        },
        getProfileSectionContent(user, listObjects, objectType, isEmailTemplate = false, ignoreHeader = false) {
            return new Promise(async (resolve) => {
                let applicationFormId = user.application_form;
                if (typeof applicationFormId !== 'number') {
                    applicationFormId = user.application_form_id;
                }
                let listBuilder = this.$store.getters.profileBuilderList.sort((a, b) => a.id - b.id);
                if (!listBuilder || listBuilder.length === 0) {
                    await this.$store.dispatch('reloadProfileBuilderList');
                    listBuilder = this.$store.getters.profileBuilderList.sort((a, b) => a.id - b.id);
                }
                // Find corresponding profile builder
                let profileBuilder = listBuilder.find(
                    (builder) =>
                        builder.application_builder_id === applicationFormId &&
                        builder.type === BUILDER_TYPE.PROFILE &&
                        builder.user_type === BUILDER_USER_TYPE.CLIENT
                );

                if (profileBuilder == null) {
                    // If There is no builder for profile, use builder for application instead
                    profileBuilder = listBuilder.find(
                        (builder) => builder.id === applicationFormId
                    );
                }

                if (profileBuilder == null) {
                    // For old data, which is not set applicaiton_form, find one profile builder
                    profileBuilder = listBuilder.find(
                        (builder) =>
                            builder.type === BUILDER_TYPE.PROFILE &&
                            builder.user_type === BUILDER_USER_TYPE.CLIENT
                    );
                }

                if (profileBuilder == null) {
                    // For old data, which is not set applicaiton_form, no profile builder => use application builder
                    profileBuilder = listBuilder.find(
                        (builder) =>
                            builder.type === BUILDER_TYPE.APPLICATION &&
                            builder.user_type === BUILDER_USER_TYPE.CLIENT
                    );
                }

                if (profileBuilder == null) {
                    resolve('');
                }

                const listFields = this.mergeBuilders(
                    profileBuilder,
                    listBuilder,
                    true
                ).listFields;
                if (!listFields) {
                    resolve('');
                    return;
                }
                const fields = listFields.find(
                    (field) =>
                        [FORM_TYPE.SLOT, FORM_TYPE.SECTION, FORM_TYPE.BOOKING_SECTION].includes(field.type) &&
                        this.isItemShow(user, field, listFields)
                        && field.name === objectType
                );
                if (fields) {
                    const mapDependentObjects = {};
                    mapDependentObjects[fields.label] = listObjects;

                    const content = this.getSectionContent(fields, mapDependentObjects, [], false, isEmailTemplate, ignoreHeader);
                    resolve(content);
                } else {
                    resolve('');
                }
            });
        },
        async getListChildren(user) {
            return new Promise(async (resolve, reject) => {
                const res = await axios.get(`/api/children/?user=${user.id}`);
                if (!res) {
                    reject();
                }
                resolve(res.data);
            });
        },
        async getListPets(user) {
            return new Promise(async (resolve, reject) => {
                const res = await axios.get(`/api/pets/?user=${user.id}`);
                if (!res) {
                    reject();
                }
                resolve(res.data);
            });
        },
        // Replace all oldStr in inputStr by newStr
        replaceAllText(inputStr, oldStr, newStr) {
            if (!inputStr) {
                return "";
            }
            return inputStr.split(oldStr).join(newStr);
        },
        extractTextByPattern(input, pattern) {
            if (!input) {
                return null;
            }
            const result = input.match(pattern);
            if (result && result.length > 1) {
                return result[1];
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/string-substitution.js